/**
 * ? @description : Login Component
 */

// Dependencies
import React, { useRef, useState } from "react";
import { Form, Alert, Row, Col, Container } from "react-bootstrap";
import {
  InputGroup,
  FormControl,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// Redux Component
import { login } from "../redux/features/userSlice";
import { showSnackbar } from "../redux/features/appSlice";

// CSS Component
import "./../../css/Login.css";

// Axios Component
import axios from "../../axios/Axios";
import { LoadingButton } from "@mui/lab";
import { setTemplate } from "../redux/features/templateSlice";
import Axios from "../../axios/Axios";

// Alert Message Component
const AlertMessage = ({ show, message }) => {
  if (show) {
    return <Alert variant="danger">{message}</Alert>;
  } else {
    return <></>;
  }
};

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const get_emailid = useRef(null);

  const [loginData, setLoginData] = useState({
    email_id: "",
    password: "",
    spoc_login: false,
  });
  // console.log(loginData)
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // API Request - Login
  async function handleSubmit(e) {
    e.preventDefault();

    if (loginData.email_id !== "" && loginData.password) {
      try {
        // setShowAlert(false);
        setLoading(true);
        const options = {
          method: "post",
          url: "/adminlogin/login/admin",
          auth: false,
          data: loginData,
        };

        const response = await axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 200) {
          // setLoading(false);
          setLoginData({ email_id: "", password: "" });
          // console.log(response);
          sessionStorage.setItem("user_token", response.data.access_token);
          sessionStorage.setItem("email_id", loginData.email_id);
          sessionStorage.setItem("user_id", response.data.user_id);
          sessionStorage.setItem("username", response.data.username);
          sessionStorage.setItem("role", response.data.role);
          sessionStorage.setItem("first_name", response.data.first_name);
          sessionStorage.setItem("last_name", response.data.last_name);

          dispatch(
            login({
              email_id: loginData.email_id,
              userrole: response.data.role,
              access_token: response.data.access_token,
            })
          );

          if (response.data.role === "admin") {
            navigate("/dashboard");
            try {
              const options = {
                method: "get",
                url: "template/view",
                auth: true,
                data: null,
              };

              const getTemplates = await Axios(
                options.method,
                options.url,
                options.auth,
                options.data
              );

              if (getTemplates.status === 200) {
                dispatch(setTemplate(getTemplates.data));
                // window.location.reload();
              }
            } catch (err) {
              dispatch(
                showSnackbar({
                  severity: "error",
                  message: "An error occured, unable to update template",
                })
              );
            }
          } else {
            navigate("/spoc/training");
          }

          dispatch(
            showSnackbar({ message: "Login Successful", severity: "success" })
          );
        } else if (response.status === 202) {
          // console.log(response.data.message);
          setLoading(false);
          setShowAlert(true);
          dispatch(
            showSnackbar({ message: response.data.message, severity: "error" })
          );
        } else if (response.status === 404) {
          setLoading(false);
          console.log(response.data);
          setShowAlert(true);
          dispatch(
            showSnackbar({ message: response.data.message, severity: "error" })
          );
          console.log("No authenticated role");
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
        setShowAlert(true);
        dispatch(
          showSnackbar({
            message: error.message || error.data.message,
            severity: "error",
          })
        );
      }
    } else {
      dispatch(
        showSnackbar({
          message: "Please enter a valid Email and Password",
          severity: "error",
        })
      );
    }
  }

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        height: "85vh",
        justifyContent: "space-between",
      }}
    >
      <Row>
        <Col
          md={{ span: 8, offset: 2 }}
          lg={{ span: 6, offset: 3 }}
          xl={{ span: 4, offset: 4 }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Login Container */}
          <div className="login-container">
            {/* Alert Message */}
            <AlertMessage
              show={showAlert}
              message="Invalid username or password"
            />

            {/* Login - Input Form */}
            <div className="login_form">
              {/* Title */}
              <h1 className="login-title">LTE - Admin Login</h1>

              {/* Input Fields */}
              <Form onSubmit={(e) => handleSubmit(e)}>
                <Form.Group className="mb-3 login-title">
                  <Form.Label>Email ID</Form.Label>
                  <Form.Control
                    type="email"
                    name="email_id"
                    placeholder="Email"
                    value={loginData.email_id}
                    ref={get_emailid}
                    onChange={(event) => {
                      setShowAlert(false);
                      setLoginData({
                        ...loginData,
                        email_id: event.target.value.toLowerCase(),
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3 login-title">
                  <Form.Label>Password</Form.Label>
                  <InputGroup className="mb-3">
                    <FormControl
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={loginData.password}
                      onChange={(event) => {
                        setShowAlert(false);
                        setLoginData({
                          ...loginData,
                          password: event.target.value,
                        });
                      }}
                    />
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip>
                          {showPassword ? "Hide Password" : "Show Password"}
                        </Tooltip>
                      }
                    >
                      <InputGroup.Text>
                        <span
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </span>
                      </InputGroup.Text>
                    </OverlayTrigger>
                  </InputGroup>
                </Form.Group>
                <Form>
                  <Form.Check
                    type="checkbox"
                    id="spoc"
                    label="Login as Spoc"
                    value="spoc"
                    onChange={(e) => {
                      // setLoginCheck(e.target.checked);
                      setLoginData({
                        ...loginData,
                        spoc_login: e.target.checked,
                      });
                    }}
                  />
                </Form>

                {/* Button */}
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  type="submit"
                  className="login-submit-button"
                >
                  Login
                </LoadingButton>
              </Form>
            </div>
          </div>

          <p className="login-forgot-text">
            Forgot&nbsp;&nbsp;
            <Link to="password/forgot">Password</Link>
            {/* <Link to={'password/forgot'}Password/>
            <a href="password/forgot">Password</a> */}
            &nbsp;?
          </p>
        </Col>
      </Row>
      <Row
      //  style={{ paddingBottom: "100px" }}
      >
        <p className="product">
          <Link to="/privacypolicy">Privacy Policy</Link>
          <br />
          Designed & Powered by{" "}
          <a href="https://blackwinstech.com/" target="_blank" rel="noreferrer">
            {" "}
            Blackwins Tech Solutions
          </a>
        </p>
      </Row>
    </Container>
  );
}

export default Login;
